import './toggle.css'
export const ToggleSwitch = (props) => {
    return (
        <div id='mainPageToggle'>
            <label className='toggle-label'>
                <input className='toggle-checkbox' readOnly type="checkbox" checked={(props.toggle == 1) ? true : false} onClick={(e) => { props.setToggle(!props.toggle) }} />
                <span className='toggle-span' >{(props.toggle == true) ?
                    <>&nbsp;&nbsp;&nbsp;FO Level</> :
                    <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Drop Level</>}</span>
            </label>
        </div>
    )
}